import { useDispatch, useSelector } from "react-redux";
import { beneCategories } from "../redux/features/beneficiary/beneAllVerification/beneAllVerification";
import { useEffect } from "react";

export default function useCategories() {
  const dispatch = useDispatch();
  const { beneTransCategories } = useSelector(
    (state) => state.beneAllVerification,
  );

  // if (beneTransCategories.categories.length === 0) {
  //   (async () => {
  //     let response = await dispatch(beneCategories());
  //   })();
  // }
  useEffect(() => {
    if (!beneTransCategories?.categories?.length) {
      dispatch(beneCategories());
    }
  }, [beneTransCategories, dispatch]);

  let map = {};
  for (let category of beneTransCategories.categories) {
    // eslint-disable-next-line no-new-wrappers
    let string = new String(
      category?.logo_url ??
        "https://q2pay.in/new_assets/web/beneficiary_category_default.svg",
    );
    string["colour"] = "var(--text-primary)"; // reserved for future use
    map[category.name] = string;
  }

  return function (name) {
    return (
      map[name] ??
      "https://q2pay.in/new_assets/web/beneficiary_category_default.svg"
    );
  };
}

/*
 will be used like so
 let category = categoryMapper(categoryName);
<SVGComponent 
  url ={category}
  color={category.colour}
/>
 
This does not break compatibility with existing code

*/
